var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoBorderNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.167 8.83335C18.167 13.6658 14.5107 18.1667 10.0003 18.1667C8.54297 18.1667 0.666992 18.1667 0.666992 18.1667C0.666992 18.1667 2.18691 16.8769 2.70866 15.8334C3.29199 14.6667 3.26121 14.1074 2.75205 12.9955C2.16531 11.7141 1.83366 10.2888 1.83366 8.83335C1.83366 4.00086 5.49 0.666687 10.0003 0.666687C14.5107 0.666687 18.167 4.00086 18.167 8.83335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBorderNoteIcon);
export default __webpack_public_path__ + "static/media/no-border-note-icon.62bf135fd9d8919ce18ce41e38aecf53.svg";
export { ForwardRef as ReactComponent };